import { ComponentSettings, FieldTypes, empty } from "../settings/settings";

const field = {
  session: {
    type: FieldTypes.data,
    text: {
      de: "Session",
      en: "session",
    },
  },
  time: {
    type: FieldTypes.timestamp,
    text: {
      de: "Zeit",
      en: "Time",
    },
  },
  timeISO: {
    type: FieldTypes.value,
    text: {
      de: "Zeit (ISO)",
      en: "Zeit (ISO)",
    },
  },
  element: {
    type: FieldTypes.value,
    text: {
      de: "Element",
      en: "Element",
    },
  },
  action: {
    type: FieldTypes.value,
    text: {
      de: "Aktion",
      en: "Action",
    },
  },
  error: {
    type: FieldTypes.data,
    text: {
      de: "Fehler",
      en: "Error",
    },
  },
  doc: {
    type: FieldTypes.data,
    text: {
      de: "Dokument",
      en: "Document",
    },
  },
  app: {
    type: FieldTypes.data,
    text: {
      de: "App",
      en: "App",
    },
  },
};

const settings = {
  permission: {},
  text: {
    error: { de: "Fehlermeldung", en: "Error Message" },
    errors: { de: "Fehlermeldungen", en: "Error Messages" },
    headerMessage: {
      de: "Es ist ein Fehler aufgetreten",
      en: "Something went wrong",
      nl: "Er is iets misgegaan",
    },
    subtitleMessageL1: {
      de: "Ihre Anfrage konnte nicht abgeschlossen werden",
      en: "Your request couldn't be completed",
      nl: "Uw verzoek kon niet worden voltooid",
    },
    subtitleMessageL2: {
      de: "Bitte wenden Sie sich mit den unten angegebenen Details an Ihren Systemadministrator oder an AMSYS",
      en: "Please contact your system administrator or AMSYS with the details below",
      nl: "Neem contact op met uw systeembeheerder of AMSYS met onderstaande gegevens",
    },
    goBackButton: {
      de: "Zurück",
      en: "Go back",
      nl: "Terug",
    },
  },
  url: {},
  field,
  list: {
    columns: empty,
  },
  additionalInfo: {},
};

export const error: ComponentSettings<typeof settings> = settings;
